// import { connect } from 'react-redux';

import {
    ProductConfigurableAttributesContainer as SourceProductConfigurableAttributesContainer
} from 'SourceComponent/ProductConfigurableAttributes/ProductConfigurableAttributes.container';
import { getQueryParam } from 'Util/Url';

/** @namespace Bodypwa/Component/ProductConfigurableAttributes/Container */
export class ProductConfigurableAttributesContainer extends SourceProductConfigurableAttributesContainer {
    static propTypes = {
        ...SourceProductConfigurableAttributesContainer.propTypes
    };

    containerFunctions = {
        handleOptionClick: this.handleOptionClick.bind(this),
        getSubHeading: this.getSubHeading.bind(this),
        isSelected: this.isSelected.bind(this),
        getLink: this.getLink.bind(this),
        getIsConfigurableAttributeAvailable: this.getIsConfigurableAttributeAvailable.bind(this)
    };

    containerProps() {
        const {
            configurable_options,
            isExpandable,
            isReady,
            mix,
            numberOfPlaceholders,
            parameters,
            showProductAttributeAsLink,
            updateConfigurableVariant,
            inStock,
            variants,
            productUrl,
            isSwiper,
            isMobile,
            variantsPage
        } = this.props;

        return {
            configurable_options,
            isExpandable,
            isReady,
            mix,
            numberOfPlaceholders,
            parameters,
            showProductAttributeAsLink,
            updateConfigurableVariant,
            inStock,
            variants,
            productUrl,
            isSwiper,
            isMobile,
            variantsPage
        };
    }

    state = {
        selectedOption: {},
        optionsToSelect: {}
    };

    componentDidUpdate() {
        const {
            product: { variants } = {}, updateConfigurableVariant, sku
        } = this.props;

        const { optionsToSelect: { attribute_code, attribute_value } } = this.state;

        if ((!sku && attribute_code) || (variants?.length > 1 && attribute_code)) {
            updateConfigurableVariant(attribute_code, attribute_value);
            this.setState({ optionsToSelect: {} });
        }
    }

    isSelected({ attribute_code, attribute_value, attribute_values }) {
        const { parameters = {}, updateConfigurableVariant } = this.props;
        const parameter = parameters[attribute_code];
        const selectedFiltersString = this._formatSelectedFiltersString((getQueryParam('customFilters', location) || '')
            .split(';'));
        const { selectedOption } = this.state;

        if (parameter === undefined) {
            if (selectedFiltersString[attribute_code]
                               && selectedFiltersString[attribute_code].includes(attribute_value)
                               && selectedOption.attribute_value === undefined) {
                updateConfigurableVariant(attribute_code, attribute_value);
                this.setState({ selectedOption: { attribute_code, attribute_value } });
                return true;
            }

            return false;
        }

        if (parameter.length !== undefined) {
            return parameter.includes(attribute_value);
        }

        if (attribute_values.length === 1) {
            return true;
        }

        return parameter === attribute_value;
    }

    handleOptionClick({ attribute_code, attribute_value }) {
        const {
            sku, categoryId, requestProductListVariants, product: { variants, page } = {}
        } = this.props;

        if ((!variants || variants?.length <= 1) && sku) {
            requestProductListVariants({
                args: {
                    filter: { productsSkuArray: [sku] }
                },
                id: categoryId,
                page,
                isPdp: false
            });
        }

        this.setState({ optionsToSelect: { attribute_code, attribute_value } });
    }

    _formatSelectedFiltersString(string) {
        return string.reduce((acc, filter) => {
            if (!filter) {
                return acc;
            }
            const [key, value] = filter.split(':');

            return { ...acc, [key]: value.split(',') };
        }, {});
    }
}

export default ProductConfigurableAttributesContainer;
